import XLRLogger from '../common/helpers/logger';
import { CommandMenuType } from '../common/interfaces/states/IPosUiMenuState';
import { store } from '../common/redux/configure-store';
import { PosUiMenuActions } from '../common/redux/reducers/pos-ui-menu-reducer';
import { defaultLogOffMenu } from './default-command-menus';
import { getMenuConfig } from './service/pos-configuration';

export const getLogOffMenu = async (): Promise<void> => {
  await getMenuConfig(CommandMenuType.LogOff)
    .then(logOffMenu => {
      store.dispatch(PosUiMenuActions.set(logOffMenu));
    })
    .catch(err => {
      XLRLogger.error({
        message: 'Failed to get log off menu from BFF',
        data: err,
        source: 'getLogOffMenu',
      });
      store.dispatch(PosUiMenuActions.set(defaultLogOffMenu));
    });
};
